module.exports = __webpack_public_path__ + "assets/img/0608.186dcaf3.svg";